import {
    Box,
    IconButton,
    TextField,
    Typography,
    useTheme,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useNotes } from "../context/NotesContext";
import { useEffect } from "react";

export default function Board() {
    const { notes, handleFieldsChanges, removeNote } = useNotes();
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === "dark";
    const location = useLocation();
    const navigate = useNavigate();
    const { id, isNewNote } = location.state || {};
    const currentNote = notes.find((note) => note.id === id);

    useEffect(() => {
        if (!id || !currentNote) {
            navigate("/", { replace: true });
        }
    }, [id, currentNote, navigate]);

    if (!currentNote) return null;

    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                padding: "25px",
                boxSizing: "border-box",
            }}
        >
            {currentNote && (
                <>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px",
                            bgcolor: "background.default",
                            borderRadius: "12px",
                        }}
                    >
                        <IconButton component={Link} to="/">
                            <KeyboardBackspaceIcon />
                        </IconButton>
                        <Typography
                            color="text.primary"
                            sx={{
                                margin: "0 10px",
                                flexGrow: "1",
                                userSelect: "none",
                            }}
                        >
                            {isNewNote && !currentNote.title
                                ? "New Note"
                                : currentNote.title}
                        </Typography>

                        <IconButton
                            onClick={() => {
                                removeNote(currentNote.id);
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            padding: "20px",
                            flexGrow: "1",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "10px",
                                mb: 1,
                            }}
                        >
                            <TextField
                                variant="standard"
                                placeholder="title..."
                                value={currentNote.title}
                                autoComplete="off"
                                onChange={(e) =>
                                    handleFieldsChanges(
                                        currentNote.id,
                                        "title",
                                        e.target.value.slice(0, 30)
                                    )
                                }
                                InputProps={{
                                    maxLength: 50,
                                    autoComplete: "off",
                                    disableUnderline: true,
                                    sx: {
                                        fontSize: "1.3rem",
                                        fontWeight: "bold",
                                    },
                                }}
                                sx={{
                                    flexGrow: "1",
                                }}
                            />
                            <Typography variant="caption" color="textSecondary">
                                {currentNote.title.length} / 30
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                flexGrow: 1,
                                position: "relative",
                                display: "flex",
                                flexDirection: "column",
                                backgroundImage: `linear-gradient(to bottom, ${
                                    isDarkMode
                                        ? "rgba(255,255,255,0.1)"
                                        : "rgba(0,0,0,0.1)"
                                }  1px, transparent 1px)`,
                                backgroundSize: `100% 24px`,
                                boxSizing: "border-box",
                                overflow: "hidden",
                            }}
                        >
                            <TextField
                                variant="standard"
                                placeholder="content..."
                                value={currentNote.note}
                                autoComplete="off"
                                onChange={(e) =>
                                    handleFieldsChanges(
                                        currentNote.id,
                                        "note",
                                        e.target.value
                                    )
                                }
                                multiline
                                fullWidth
                                sx={{
                                    flexGrow: 1,
                                    background: "transparent",
                                    "& .MuiInputBase-input": {
                                        height: "100%",
                                        padding: 0,
                                        margin: 0,
                                        lineHeight: "24px",
                                        fontSize: "1rem",
                                        whiteSpace: "pre-wrap",
                                        overflow: "auto",
                                    },
                                }}
                                InputProps={{
                                    autoComplete: "off",
                                    disableUnderline: true,
                                }}
                            />
                        </Box>
                    </Box>
                </>
            )}
        </Box>
    );
}
